import { AgentRegistry } from "./AgentRegistry";
import { applicationState, authenticationService } from "./App";

export interface LabelTemplate {
    file?: File;
    path: string;
    metadata: { [key: string]: string; };
}

export interface LabelTemplateFields {
    [key: string]: any;
}

export interface PrintOptions {
    copies?: number;
    noAutoCut?: boolean;
    overrideMetadata?: boolean;
}

export interface PrintQueueEntry {
    template: LabelTemplate;
    fields: { [key: string]: string };
    rawFields?: { [key: string]: string };
    options?: PrintOptions;
}

export interface PrinterInfo {
    portName: string;
    mediaPresent: boolean;
    mediaType: number;
    mediaWidth: number;
    busy?: boolean;
}

export class AgentRegistryLabelPrinterModule {
    constructor(
        private registry: AgentRegistry
    ) {

    }

    async getPrinterInfo(agent: string) {
        const response = await this.registry.request({
            to: agent,
            command: "info",
            user: authenticationService.currentlyLoggedInUser?.email
        });

        if (response.ok) {
            return JSON.parse(response.getPayload()) as PrinterInfo;
        }

        return { portName: null } as { portName: null };
    }
}
